import React, { Component } from 'react';
import HistoryCursorBorder from './history-cursor-border';
import PropTypes from 'prop-types';

class ElementOverlay extends Component<any> {
    public static propTypes = {
        element: PropTypes.object.isRequired,
        historyManager: PropTypes.object.isRequired,
    };

    public render() {
        return (
            <HistoryCursorBorder
                element={this.props.element}
                historyManager={this.props.historyManager}
            >
            </HistoryCursorBorder>
        );
    }
}

export default ElementOverlay;
